// extracted by mini-css-extract-plugin
var _1 = "v1lV7";
var _2 = "sYCh4";
export { _1 as "base", _2 as "tabs" }
